import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05179ff6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "dashboard-container"
}
const _hoisted_2 = { class: "latest-accounts d-container" }
const _hoisted_3 = { class: "header-filters" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, "Latest created Accounts", -1))
const _hoisted_5 = { class: "p-input-icon-left" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "latest-license-activations d-container" }
const _hoisted_9 = { class: "header-filters" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, "Licenses expiring soon", -1))
const _hoisted_11 = { class: "p-input-icon-left" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "latest-license-activations d-container" }
const _hoisted_15 = { class: "header-filters" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, "Latest License Activations", -1))
const _hoisted_17 = { class: "p-input-icon-left" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "latest-license-activations d-container" }
const _hoisted_21 = { class: "header-filters" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, "Latest Updates", -1))
const _hoisted_23 = { class: "p-input-icon-left" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "active-entities d-container" }
const _hoisted_27 = { class: "header-filters" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, "Active Accounts and Licenses", -1))
const _hoisted_29 = { class: "date-filter" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "date-label" }, "From", -1))
const _hoisted_31 = { class: "date-filter" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "date-label" }, "To", -1))
const _hoisted_33 = { class: "canvas-toggle" }
const _hoisted_34 = {
  key: 1,
  class: "dashboard-container"
}
const _hoisted_35 = { class: "customer-licenses-info d-container" }
const _hoisted_36 = { class: "lm-progress-bar" }
const _hoisted_37 = { class: "lm-row" }
const _hoisted_38 = { class: "lm-column" }
const _hoisted_39 = { class: "header" }
const _hoisted_40 = { class: "lm-column" }
const _hoisted_41 = { class: "header" }
const _hoisted_42 = { class: "lm-column" }
const _hoisted_43 = { class: "header" }
const _hoisted_44 = { class: "lm-column" }
const _hoisted_45 = { class: "customer-activations-info d-container" }
const _hoisted_46 = { class: "header-filters" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, "Latest Activations (Top 25)", -1))
const _hoisted_48 = { class: "p-input-icon-left" }
const _hoisted_49 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_Chart = _resolveComponent("Chart")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!

  return (_ctx.isAdminOrEmployee)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_DataTable, {
            id: "id",
            class: "latest-accounts-dt",
            scrollHeight: "flex",
            stripedRows: "",
            selectionMode: "single",
            selection: _ctx.selectedAccount,
            "onUpdate:selection": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedAccount) = $event)),
            scrollable: true,
            value: _ctx.latestAccounts,
            rows: 10,
            rowClass: _ctx.rowClassLatestAccounts,
            rowsPerPageOptions: [25],
            filters: _ctx.activeCustomersData.filters,
            totalRecords: _ctx.latestAccounts.length,
            loading: _ctx.activeCustomersData.loading,
            globalFilterFields: _ctx.activeCustomersData.globalFilter,
            onRowDblclick: _ctx.latestAccountDblClicked
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createVNode(_component_InputText, {
                    modelValue: _ctx.activeCustomersData.filters['global'].value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeCustomersData.filters['global'].value) = $event)),
                    placeholder: "Keyword Search"
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", null, [
                    _createElementVNode("button", {
                      class: "dashboard-refresh-button",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.refreshLatestAccounts && _ctx.refreshLatestAccounts(...args)))
                    }, "Refresh"),
                    _createElementVNode("i", {
                      style: {"margin-left":"20px"},
                      class: _normalizeClass(["cursor-pointer pi", { 'pi-angle-right': !_ctx.activeCustomersData.show, 'pi-angle-down': _ctx.activeCustomersData.show }]),
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeCustomersData.show = !_ctx.activeCustomersData.show))
                    }, null, 2)
                  ])
                ])
              ])
            ]),
            empty: _withCtx(() => [
              _createTextVNode("No accounts found.")
            ]),
            loading: _withCtx(() => [
              _createTextVNode("Loading accounts. Please wait.")
            ]),
            default: _withCtx(() => [
              (_ctx.activeCustomersData.show)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_component_Column, {
                      field: "company",
                      header: "Company",
                      style: {"min-width":"12rem","max-width":"12rem"},
                      sortable: ""
                    }),
                    _createVNode(_component_Column, {
                      field: "name",
                      header: "Name",
                      style: {"min-width":"8rem","max-width":"8rem"},
                      sortable: ""
                    }),
                    _createVNode(_component_Column, {
                      field: "surname",
                      header: "Surname",
                      style: {"min-width":"8rem","max-width":"8rem"},
                      sortable: ""
                    }),
                    _createVNode(_component_Column, {
                      field: "email",
                      header: "Email",
                      sortable: "",
                      style: {"min-width":"20rem","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"}
                    }),
                    _createVNode(_component_Column, {
                      field: "createdBy",
                      header: "Created By",
                      style: {"min-width":"8rem","max-width":"8rem"},
                      sortable: ""
                    }),
                    _createVNode(_component_Column, {
                      field: "emailConfirmed",
                      header: "Mail Validated",
                      style: {"min-width":"8rem","max-width":"8rem"},
                      sortable: ""
                    }, {
                      body: _withCtx(({ data }) => [
                        _createElementVNode("div", {
                          class: _normalizeClass(_ctx.mailValidatedClass(data))
                        }, _toDisplayString(data.emailConfirmed ? 'Yes' : 'No'), 3)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "createdDate",
                      header: "Creation Date",
                      style: {"min-width":"8rem","max-width":"8rem"},
                      sortable: ""
                    }, {
                      body: _withCtx(({ data }) => [
                        _createTextVNode(_toDisplayString(_ctx.df.format(data.createdDate)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "activationsCount",
                      header: "Act",
                      style: {"min-width":"5rem","max-width":"5rem"},
                      sortable: ""
                    }, {
                      body: _withCtx(({ data }) => [
                        _createElementVNode("div", {
                          class: _normalizeClass(_ctx.hasActivationsClass(data))
                        }, _toDisplayString(data.activationsCount), 3)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "licenseExpiryDate",
                      header: "Expiry Date",
                      style: {"min-width":"12rem","max-width":"12rem"},
                      sortable: ""
                    }, {
                      body: _withCtx(({ data }) => [
                        _createElementVNode("div", {
                          class: _normalizeClass(_ctx.expiryDateClass(data))
                        }, _toDisplayString(_ctx.df.format(data.licenseExpiryDate) +
                  ' (' +
                  Math.max(
                    Math.ceil(
                      (_ctx.getDefaultDate(new Date(data.licenseExpiryDate)).getTime() - _ctx.getDefaultDate(new Date()).getTime()) /
                        (1000 * 3600 * 24)
                    ),
                    0
                  ) +
                  ' days)'), 3)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["selection", "value", "rowClass", "filters", "totalRecords", "loading", "globalFilterFields", "onRowDblclick"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_DataTable, {
            id: "id",
            class: "latest-accounts-dt",
            scrollHeight: "flex",
            stripedRows: "",
            selectionMode: "single",
            scrollable: true,
            value: _ctx.expiringLicenses,
            rows: 10,
            rowsPerPageOptions: [25],
            filters: _ctx.expiringLicensesData.filters,
            totalRecords: _ctx.expiringLicenses.length,
            loading: _ctx.expiringLicensesData.loading,
            globalFilterFields: _ctx.expiringLicensesData.globalFilter,
            onRowDblclick: _ctx.soonExpiringLicensesDblClicked
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createVNode(_component_InputText, {
                    modelValue: _ctx.expiringLicensesData.filters['global'].value,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.expiringLicensesData.filters['global'].value) = $event)),
                    placeholder: "Keyword Search"
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", null, [
                    _createElementVNode("button", {
                      class: "dashboard-refresh-button",
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.refreshExpiringLicenses && _ctx.refreshExpiringLicenses(...args)))
                    }, "Refresh"),
                    _createElementVNode("i", {
                      style: {"margin-left":"20px"},
                      class: _normalizeClass(["cursor-pointer pi", { 'pi-angle-right': !_ctx.expiringLicensesData.show, 'pi-angle-down': _ctx.expiringLicensesData.show }]),
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.expiringLicensesData.show = !_ctx.expiringLicensesData.show))
                    }, null, 2)
                  ])
                ])
              ])
            ]),
            empty: _withCtx(() => [
              _createTextVNode("No licenses found.")
            ]),
            loading: _withCtx(() => [
              _createTextVNode("Loading accounts. Please wait.")
            ]),
            default: _withCtx(() => [
              (_ctx.expiringLicensesData.show)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createVNode(_component_Column, {
                      field: "company",
                      header: "Company",
                      style: {"min-width":"12rem","max-width":"12rem"},
                      sortable: ""
                    }),
                    _createVNode(_component_Column, {
                      field: "name",
                      header: "Name",
                      style: {"min-width":"8rem","max-width":"8rem"},
                      sortable: ""
                    }),
                    _createVNode(_component_Column, {
                      field: "surname",
                      header: "Surname",
                      style: {"min-width":"8rem","max-width":"8rem"},
                      sortable: ""
                    }),
                    _createVNode(_component_Column, {
                      field: "email",
                      header: "Email",
                      sortable: "",
                      style: {"min-width":"20rem","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"}
                    }),
                    _createVNode(_component_Column, {
                      field: "stripeSubscriptionStatus",
                      header: "Stripe Status",
                      style: {"min-width":"8rem","max-width":"8rem"},
                      sortable: ""
                    }),
                    _createVNode(_component_Column, {
                      field: "stripeCancelAt",
                      header: "Stripe Cancel At",
                      style: {"min-width":"8rem","max-width":"8rem"},
                      sortable: ""
                    }, {
                      body: _withCtx(({ data }) => [
                        _createTextVNode(_toDisplayString(_ctx.df.format(data.stripeCancelAt)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "activationsCount",
                      header: "Act",
                      style: {"min-width":"5rem","max-width":"5rem"},
                      sortable: ""
                    }, {
                      body: _withCtx(({ data }) => [
                        _createElementVNode("div", {
                          class: _normalizeClass(_ctx.hasActivationsClass(data))
                        }, _toDisplayString(data.activationsCount), 3)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "licenseExpiryDate",
                      header: "Expiry Date",
                      style: {"min-width":"12rem","max-width":"12rem"},
                      sortable: ""
                    }, {
                      body: _withCtx(({ data }) => [
                        _createElementVNode("div", {
                          class: _normalizeClass(_ctx.expiryDateExpiringSoonClass(data))
                        }, _toDisplayString(_ctx.df.format(data.expiryDate) +
                  ' (' +
                  Math.max(
                    Math.ceil(
                      (_ctx.getDefaultDate(new Date(data.expiryDate)).getTime() - _ctx.getDefaultDate(new Date()).getTime()) / (1000 * 3600 * 24)
                    ),
                    0
                  ) +
                  ' days)'), 3)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["value", "filters", "totalRecords", "loading", "globalFilterFields", "onRowDblclick"])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_DataTable, {
            id: "autoId",
            class: "latest-license-activations-dt",
            scrollHeight: "flex",
            stripedRows: "",
            selectionMode: "single",
            selection: _ctx.selectedActivation,
            "onUpdate:selection": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedActivation) = $event)),
            scrollable: true,
            value: _ctx.latestActivations,
            rows: 10,
            rowClass: _ctx.rowClass,
            rowsPerPageOptions: [25],
            filters: _ctx.latestActivationsData.filters,
            totalRecords: _ctx.latestActivationsData.length,
            loading: _ctx.latestActivationsData.loading,
            globalFilterFields: _ctx.latestActivationsData.globalFilter,
            onRowDblclick: _ctx.latestActivationDblClicked
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("span", _hoisted_17, [
                  _hoisted_18,
                  _createVNode(_component_InputText, {
                    modelValue: _ctx.latestActivationsData.filters['global'].value,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.latestActivationsData.filters['global'].value) = $event)),
                    placeholder: "Keyword Search"
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", null, [
                    _createElementVNode("button", {
                      class: "dashboard-refresh-button",
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.refreshLatestActivations && _ctx.refreshLatestActivations(...args)))
                    }, "Refresh"),
                    _createElementVNode("i", {
                      style: {"margin-left":"20px"},
                      class: _normalizeClass(["cursor-pointer pi", { 'pi-angle-right': !_ctx.latestActivationsData.show, 'pi-angle-down': _ctx.latestActivationsData.show }]),
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.latestActivationsData.show = !_ctx.latestActivationsData.show))
                    }, null, 2)
                  ])
                ])
              ])
            ]),
            empty: _withCtx(() => [
              _createTextVNode("No accounts found.")
            ]),
            loading: _withCtx(() => [
              _createTextVNode("Loading accounts. Please wait.")
            ]),
            default: _withCtx(() => [
              (_ctx.latestActivationsData.show)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createVNode(_component_Column, {
                      field: "company",
                      header: "Company",
                      style: {"min-width":"12rem","max-width":"12rem"},
                      sortable: ""
                    }),
                    _createVNode(_component_Column, {
                      field: "accountName",
                      header: "Account Name",
                      style: {"min-width":"8rem","max-width":"8rem"},
                      sortable: ""
                    }),
                    _createVNode(_component_Column, {
                      field: "accountSurname",
                      header: "Account Surname",
                      style: {"min-width":"8rem","max-width":"8rem"},
                      sortable: ""
                    }),
                    _createVNode(_component_Column, {
                      field: "accountEmail",
                      header: "Account Email",
                      style: {"min-width":"18rem","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"},
                      sortable: ""
                    }),
                    _createVNode(_component_Column, {
                      field: "activationInfo.computerName",
                      style: {"min-width":"8rem","max-width":"10rem","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"},
                      header: "Computer Name",
                      sortable: ""
                    }),
                    _createVNode(_component_Column, {
                      field: "activationInfo.userDomainName",
                      header: "User Domain Name",
                      sortable: ""
                    }),
                    _createVNode(_component_Column, {
                      field: "activationInfo.userName",
                      header: "Activation UserName",
                      sortable: ""
                    }),
                    _createVNode(_component_Column, {
                      field: "createTime",
                      header: "Creation Date",
                      sortable: ""
                    }, {
                      body: _withCtx(({ data }) => [
                        _createTextVNode(_toDisplayString(_ctx.df.format(data.createTime)), 1)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["selection", "value", "rowClass", "filters", "totalRecords", "loading", "globalFilterFields", "onRowDblclick"])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_DataTable, {
            id: "autoId",
            class: "latest-license-activations-dt",
            scrollHeight: "flex",
            stripedRows: "",
            selectionMode: "single",
            selection: _ctx.selectedActivation,
            "onUpdate:selection": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.selectedActivation) = $event)),
            scrollable: true,
            value: _ctx.latestValidations,
            rows: 10,
            rowClass: _ctx.rowClass,
            rowsPerPageOptions: [25],
            filters: _ctx.latestValidationsData.filters,
            totalRecords: _ctx.latestValidationsData.length,
            loading: _ctx.latestValidationsData.loading,
            globalFilterFields: _ctx.latestValidationsData.globalFilter,
            onRowDblclick: _ctx.latestActivationDblClicked
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("span", _hoisted_23, [
                  _hoisted_24,
                  _createVNode(_component_InputText, {
                    modelValue: _ctx.latestValidationsData.filters['global'].value,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.latestValidationsData.filters['global'].value) = $event)),
                    placeholder: "Keyword Search"
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", null, [
                    _createElementVNode("button", {
                      class: "dashboard-refresh-button",
                      onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.refreshLatestValidations && _ctx.refreshLatestValidations(...args)))
                    }, "Refresh"),
                    _createElementVNode("i", {
                      style: {"margin-left":"20px"},
                      class: _normalizeClass(["cursor-pointer pi", { 'pi-angle-right': !_ctx.latestValidationsData.show, 'pi-angle-down': _ctx.latestValidationsData.show }]),
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.latestValidationsData.show = !_ctx.latestValidationsData.show))
                    }, null, 2)
                  ])
                ])
              ])
            ]),
            empty: _withCtx(() => [
              _createTextVNode("No accounts found.")
            ]),
            loading: _withCtx(() => [
              _createTextVNode("Loading accounts. Please wait.")
            ]),
            default: _withCtx(() => [
              (_ctx.latestValidationsData.show)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createVNode(_component_Column, {
                      field: "company",
                      header: "Company",
                      style: {"min-width":"12rem","max-width":"12rem"},
                      sortable: ""
                    }),
                    _createVNode(_component_Column, {
                      field: "accountName",
                      header: "Account Name",
                      style: {"min-width":"8rem","max-width":"8rem"},
                      sortable: ""
                    }),
                    _createVNode(_component_Column, {
                      field: "accountSurname",
                      header: "Account Surname",
                      style: {"min-width":"8rem","max-width":"8rem"},
                      sortable: ""
                    }),
                    _createVNode(_component_Column, {
                      field: "activationInfo.computerName",
                      style: {"min-width":"8rem","max-width":"10rem","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"},
                      header: "Computer Name",
                      sortable: ""
                    }),
                    _createVNode(_component_Column, {
                      field: "activationInfo.userDomainName",
                      header: "User Domain Name",
                      sortable: ""
                    }),
                    _createVNode(_component_Column, {
                      field: "activationInfo.userName",
                      header: "Activation UserName",
                      sortable: ""
                    }),
                    _createVNode(_component_Column, {
                      field: "activationInfo.productVersion",
                      header: "Product Version",
                      sortable: ""
                    }),
                    _createVNode(_component_Column, {
                      field: "modifiedTime",
                      header: "Modified Date",
                      sortable: ""
                    }, {
                      body: _withCtx(({ data }) => [
                        _createTextVNode(_toDisplayString(_ctx.df.format(data.modifiedTime)), 1)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["selection", "value", "rowClass", "filters", "totalRecords", "loading", "globalFilterFields", "onRowDblclick"])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _createVNode(_component_Datepicker, {
                modelValue: _ctx.activeEntitiesData.dateFrom,
                "onUpdate:modelValue": [
                  _cache[15] || (_cache[15] = ($event: any) => ((_ctx.activeEntitiesData.dateFrom) = $event)),
                  _ctx.loadActiveEntitiesData
                ],
                autoApply: "",
                clearable: false,
                enableTimePicker: false
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              _createVNode(_component_Datepicker, {
                modelValue: _ctx.activeEntitiesData.dateTo,
                "onUpdate:modelValue": [
                  _cache[16] || (_cache[16] = ($event: any) => ((_ctx.activeEntitiesData.dateTo) = $event)),
                  _ctx.loadActiveEntitiesData
                ],
                autoApply: "",
                clearable: false,
                enableTimePicker: false
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("i", {
                style: {"margin-left":"20px"},
                class: _normalizeClass(["cursor-pointer pi", { 'pi-angle-right': !_ctx.activeEntitiesData.show, 'pi-angle-down': _ctx.activeEntitiesData.show }]),
                onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.activeEntitiesData.show = !_ctx.activeEntitiesData.show))
              }, null, 2)
            ])
          ]),
          (_ctx.activeEntitiesData.show)
            ? (_openBlock(), _createBlock(_component_Chart, {
                key: 0,
                type: "line",
                data: _ctx.activeEntitiesData,
                options: _ctx.basicOptions
              }, null, 8, ["data", "options"]))
            : _createCommentVNode("", true)
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customerLicensesStatistic, (s, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, "Product: " + _toDisplayString(s.licenseName), 1)
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, "Active Activations Count: " + _toDisplayString(s.activeActivationsCount), 1)
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, "Max Activations Count: " + _toDisplayString(s.maximumActivations), 1)
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _createVNode(_component_ProgressBar, {
                      value: _ctx.percentage(s.activeActivationsCount, s.maximumActivations)
                    }, null, 8, ["value"])
                  ])
                ])
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_45, [
          _createVNode(_component_DataTable, {
            id: "id",
            class: "customer-activations-dt",
            scrollHeight: "flex",
            stripedRows: "",
            selection: _ctx.selectedAccount,
            "onUpdate:selection": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.selectedAccount) = $event)),
            scrollable: true,
            value: _ctx.customerActivationsStatistic,
            rows: 10,
            rowsPerPageOptions: [25],
            totalRecords: _ctx.customerData.length,
            loading: _ctx.customerData.loading,
            filters: _ctx.customerData.filters,
            globalFilterFields: _ctx.customerData.globalFilter
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_46, [
                _hoisted_47,
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", null, [
                    _createElementVNode("button", {
                      class: "dashboard-refresh-button",
                      onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.refreshCustomerStatistic && _ctx.refreshCustomerStatistic(...args)))
                    }, "Refresh"),
                    _createElementVNode("i", {
                      style: {"margin-left":"20px"},
                      class: _normalizeClass(["cursor-pointer pi", { 'pi-angle-right': !_ctx.customerData.show, 'pi-angle-down': _ctx.customerData.show }]),
                      onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.customerData.show = !_ctx.customerData.show))
                    }, null, 2)
                  ])
                ])
              ])
            ]),
            empty: _withCtx(() => [
              _createTextVNode("No activations found.")
            ]),
            loading: _withCtx(() => [
              _createTextVNode("Loading activations. Please wait.")
            ]),
            default: _withCtx(() => [
              (_ctx.customerData.show)
                ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                    _createVNode(_component_Column, {
                      field: "company",
                      header: "Company",
                      sortable: ""
                    }),
                    _createVNode(_component_Column, {
                      field: "computerName",
                      header: "Computer Name",
                      sortable: ""
                    }),
                    _createVNode(_component_Column, {
                      field: "userDomainName",
                      header: "Domain Name",
                      sortable: ""
                    }),
                    _createVNode(_component_Column, {
                      field: "userName",
                      header: "Activation User Name",
                      sortable: ""
                    }),
                    _createVNode(_component_Column, {
                      field: "createTime",
                      header: "Creation Date",
                      sortable: ""
                    }, {
                      body: _withCtx(({ data }) => [
                        _createTextVNode(_toDisplayString(_ctx.df.format(data.createTime)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "productVersion",
                      header: "Version",
                      sortable: ""
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["selection", "value", "totalRecords", "loading", "filters", "globalFilterFields"])
        ])
      ]))
}